import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodmenuService } from 'src/app/services/addfoodmenu.service';
import { FoodcourtmenuService } from 'src/app/services/foodcourtmenu.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-add-food-menu',
  templateUrl: './add-food-menu.component.html',
  styleUrls: ['./add-food-menu.component.scss']
})
export class AddFoodMenuComponent implements OnInit {

  @ViewChild('uploadImages', { static: false }) uploadImages: ElementRef;

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  prakList: any = [];
  finalSubmissionArray = [];
  afterConvertFile: any = [];
  images = [];
  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];
  currentProcessingImg: any = 0;
  imgId: any = 0;
  finalImageList: any = [];
  photoData: any = {};
  uploadData: any;
  selectedPark = localStorage.getItem('parkId');
  parkDetails;
  displayPark = '';
  imageName: any;
  menuType = [];
  menuAvability = [];
  menuCuissine = [];
  vendorId: any;

  // myForm = new FormGroup({
  //   FoodName: new FormControl(),
  //   FoodType: new FormControl(),
  //   FoodCuisine: new FormControl(),
  //   FoodPrice: new FormControl(),
  //   FoodDescription: new FormControl(),
  //   ParkId: new FormControl(),
  //   file: new FormControl(),
  //   // VendorPhotos: new FormControl(),
  //   CreatedBy: new FormControl(),
  //   isActive: new FormControl(),
  //   IsAvailable: new FormControl(),
  // });

  myForm!: FormGroup;
  imageTobeUpload: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodmenuService: AddfoodmenuService,
    private foodcourtmenuService: FoodcourtmenuService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {

    // this.myForm = this.formBuilder.group({
    //   FoodName: ['', [Validators.required, Validators.maxLength(100)]],
    //   FoodType: ['', [Validators.required]],
    //   FoodCuisine: ['', [Validators.required]],
    //   FoodPrice: ['', [Validators.required]],
    //   FoodDescription: ['', [Validators.required]],
    //   IsAvailable: ['', [Validators.required]],
    //   ParkId: [''],
    //   file: [''],
    //   VendorPhotos: [''],
    //   CreatedBy: '',
    //   isActive: true,
    // });

    this.myForm = this.formBuilder.group({
      newMenuGroups: this.formBuilder.array([this.newNotes()]),
      CreatedBy: '',
      isActive: true,
    });

    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      this.vendorId = params['id'];
    });

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');
    this.selectedPark = localStorage.getItem('parkId');

    this.foodcourt.FoodType = '';
    this.foodcourt.FoodCuisine = '';
    this.foodcourt.IsAvailable = '';

    this.menuType.push(
      {
        id: "Veg",
        name: "Veg"
      },
      {
        id: "Non-Veg",
        name: "Non-Veg"
      }
    );

    this.menuAvability.push(
      {
        id: "true",
        name: "Available"
      },
      {
        id: "false",
        name: "Not Available"
      }
    );

    this.menuCuissine.push(
      {
        id: "Indian",
        name: "Indian"
      },
      {
        id: "North Indian",
        name: "North Indian"
      },
      {
        id: "Continental",
        name: "Continental"
      },
      {
        id: "Italian",
        name: "Italian"
      },
      {
        id: "Chinese",
        name: "Chinese"
      },
      {
        id: "Japanese",
        name: "Japanese"
      },
      {
        id: "Thai",
        name: "Thai"
      },
      {
        id: "Korean",
        name: "Korean"
      },
      {
        id: "American",
        name: "American"
      },
      {
        id: "Mexican",
        name: "Mexican"
      },
      {
        id: "International",
        name: "International"
      }
    );
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.foodcourtmenuService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  onFileChange(event: any, file: any) {

    this.images = [];

    if (event.target.files && event.target.files[0]) {
      const fileItem = event.target.files[0];
      console.log(fileItem);

      var filesAmount = event.target.files.length;

      // for (let i = 0; i < filesAmount; i++) {
      //   var reader = new FileReader();
      //   reader.readAsDataURL(event.target.files[i]);

      //   reader.onload = (innerEvent: any) => {
      //     // this.imgId = this.imgId + 1;
      //     this.images.push({
      //       // imgId: this.imgId,
      //       imgBase64: innerEvent.target.result,
      //       imgFile: event.target.files[i],
      //     });

      //     this.myForm.patchValue({
      //       couponimage: this.images,
      //     });
      //   };
      // }


      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (innerEvent: any) => {
        // this.imgId = this.imgId + 1;
        this.images.push({
          imgBase64: innerEvent.target.result,
          imgFile: event.target.files[0],
        });
        // this.myForm.patchValue({
        //   couponimage: this.images,
        // });
      };

      this.imageName = event.target.files[0].name;
      console.log(event.target.files[0].name);
    }
  }

  goToListPage() {
    this.router.navigate(['/list-food-menu/' + this.vendorId]);
  }

  dataURLtoFile(dataurl: string, filename: any) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename.split('?').at(0), { type: mime });
  }

  newMenuGroups(): FormArray {
    return this.myForm.get('newMenuGroups') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      FoodName: ['', [Validators.required, Validators.maxLength(100)]],
      FoodType: ['', [Validators.required]],
      FoodCuisine: ['', [Validators.required]],
      FoodPrice: ['', [Validators.required]],
      FoodDescription: ['', [Validators.required]],
      IsAvailable: ['', [Validators.required]],
      ParkId: [''],
      file: [''],
      VendorPhotos: [''],
      CreatedBy: '',
      isActive: true,
    });
  }

  addMore(): void {
    this.newMenuGroups().push(this.newNotes());
  }

  removeBlock(i: number) {
    this.newMenuGroups().removeAt(i);
  }

  onSubmit(): void {

    if (this.myForm.valid) {

      const uploadData = new FormData();

      // for (let i = 0; i <= this.images.length - 1; i++) {
      //   this.afterConvertFile.push(
      //     this.dataURLtoFile(
      //       this.images[i].imgBase64,
      //       this.images[i].imgFile.name
      //     )
      //   );
      // }

      if (this.images.length > 0) {
        this.afterConvertFile.push(
          this.dataURLtoFile(
            this.images[0].imgBase64,
            this.images[0].imgFile.name
          )
        );
      }
      let imgFileProperties = this.afterConvertFile.map(
        (img: any, filename: any) => {
          let properties = {
            photoData: img,
            photoName: img.name,
          };
          return properties;
        }
      );


      // for (let i = 0; i <= imgFileProperties.length - 1; i++) {
      //   uploadData.append(
      //     'CouponImage[' + i + '].photoData',
      //     imgFileProperties[i].photoData
      //   );
      //   uploadData.append(
      //     'CouponImage[' + i + '].photoName',
      //     imgFileProperties[i].photoName.split('?').at(0)
      //   );
      // }


      // uploadData.append('CouponImage', imgFileProperties[0].photoName);


      // this.myForm.patchValue({
      //   CouponImage: imgFileProperties,
      // });

      //for (let i = 0; i <= this.myForm.value.newMenuGroups.length - 1; i++) {

      if (imgFileProperties.length > 0) {
        this.imageTobeUpload = imgFileProperties[0].photoData;
      } else {
        this.imageTobeUpload = null;
      }

      uploadData.append('FoodCourtVendorId', this.vendorId);
      uploadData.append('FoodName', this.myForm.value.newMenuGroups[0].FoodName);
      uploadData.append('FoodType', this.myForm.value.newMenuGroups[0].FoodType);
      uploadData.append('FoodCuisine', this.myForm.value.newMenuGroups[0].FoodCuisine);
      uploadData.append('FoodPrice', this.myForm.value.newMenuGroups[0].FoodPrice);
      uploadData.append('FoodDescription', this.myForm.value.newMenuGroups[0].FoodDescription);
      uploadData.append('IsAvailable', this.myForm.value.newMenuGroups[0].IsAvailable);
      uploadData.append('photoData', this.imageTobeUpload);
      uploadData.append('FoodImageName', this.imageName);
      uploadData.append('CreatedBy', localStorage.getItem('claAdminId'));
      uploadData.append('IsActive', 'true');

      //}

      this.finalSubmissionArray = [];
      this.addfoodmenuService
        .addFoodCourtMenu(uploadData)
        .subscribe((res) => {
          this.router.navigate(['/list-food-menu/' + this.vendorId]);
        });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  removeImage(i: any) {
    console.log(i);
    this.images.splice(i, 1);
    this.imageName = '';
  }

}
